import { Container, Row, Spinner, Table } from "react-bootstrap";
import Paginations from "../components/pagination";
import Breadcrumbs from "../components/breadcrumbs";
import AddContentType from "../components/scribe-settings-model";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { truncateText } from "../shared/utils";
import DeleteConfirmationModal from "../components/delete-confirmation-modal";
import { getSettingData } from "../shared/scribe";

const ScribeBotSettings = () => {
  const [showAddModel, setShowAddModel] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [id, setId] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    getTableData();
  }, []);
  const getTableData = () => {
    getSettingData()
      .then((data) => {
        setTableData(data);
      })
      .catch((e) => {
        console.error(e.message);
      });
  };
  const deleteContentType = (id) => {
    setDeleting(true);
    axios
      .delete(`${process.env.REACT_APP_API_URL}/scribe-bot-settings?id=${id}`)
      .then(() => {
        toast.error("Deleted successfully");
        getTableData();
        setDeleting(false);
        setDeleteModal(false);
      })
      .catch((e) => {
        console.error(e.message);
      });
  };

  return (
    <Container fluid className="p-4">
      <Breadcrumbs />
      <p className="section-title mb-5">Settings</p>
      <div className="mb-3 add-icon">
        <img
          onClick={() => {
            setShowAddModel(true);
            setId(0);
          }}
          src={"/images/plus-circle-yellow.svg"}
          height="50px"
          alt="video"
        />
      </div>
      <Row>
        <Table responsive className="scribe-contents-table">
          <thead>
            <tr>
              <th>Content Type</th>
              <th>Generation Prompt</th>
              <th>Validation Prompt</th>
              <th>Created On</th>
              <th>Updated On</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData &&
              tableData.map((val) => (
                <tr>
                  <td>{val.content_type}</td>
                  <td>{truncateText(val.default_generation_prompt, 200)}</td>
                  <td>{val.default_validation_prompt}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {new Date(val.created_on).toLocaleString()}
                  </td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    {new Date(val.updated_on).toLocaleString()}
                  </td>
                  <td>
                    <img
                      onClick={() => {
                        setShowAddModel(true);
                        setId(val.id);
                      }}
                      src={"/images/edit.svg"}
                      alt="video"
                    />
                  </td>
                  <td>
                    <img
                      onClick={() => {
                        setDeleteModal(true);
                        setId(val.id);
                      }}
                      src={"/images/delete.svg"}
                      alt="video"
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Row>
      {/* <Row>
    <Col className="d-flex justify-content-start disabled">
      Displaying  of Records
    </Col>
    <Col className="d-flex justify-content-end">
      <Paginations
        current_page={paginationData.current_page}
        page_size={paginationData.page_size}
        total_page={paginationData.total_page}
        total_records={paginationData.total_records}
        clicked_page={setPage}
    />
    </Col>
  </Row> */}
      {showAddModel && (
        <AddContentType onClose={() => setShowAddModel(false)} getData={getTableData} id={id} />
      )}
      {deleteModal && id != 0 && (
        <DeleteConfirmationModal
          loading={deleting}
          onClose={() => {
            setDeleteModal(false);
            setId(0);
          }}
          onConfirm={() => deleteContentType(id)}
          description="Are you sure you want to delete? You will miss the generated contents which generated by this content type!"
        />
      )}
    </Container>
  );
};
export default ScribeBotSettings;
